import React from 'react';

const ProductImage = (props) => {

    const Terms = props.terms.map((item, key) => {
        return (
            <li key={key} dangerouslySetInnerHTML={{__html: item}} />
        );
    });

    return (
        <div className="product-image">
            <img src={props.image} alt={props.title} />
            <span>{props.title}</span>
            <div className="price" dangerouslySetInnerHTML={{__html: props.price}} />
            <ul className="terms">
                {Terms}
            </ul>
        </div>
    );

};

export default ProductImage;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/ProductImage.js